<template>
  <div>
     
    <HeaderControls :myWeek='false' :parentDeliverableId="parentDeliverableId" @filterUpdated='filterUpdate'
    	@collapseToggleUpdated='collapseToggleUpdate' @showEditDeliverableModal="showEditDeliverableModal"
    	:namespace="namespace" :tabTitle="'content-calendar'" :pageCount="pageCount" :showCreatedPostedDateSort="isListAllView" ref="refHeaderControls" :showLogo="true"/>

    <div class="deliverable-main container-fluid">
    	<div class="deliverable-listing social-media-grouped" :class="{hasFilter: (filterQuery.status.length || filterQuery.coordinator.length || filterQuery.tag.length || filterQuery.outlet.length)}">


				<b-modal centered hide-footer id="viewTitleModal" title="Enter View Title">
					<ViewTitleModal @setActiveView="setActiveView" ref="refViewTitleModal"  :namespace="namespace"/>
				</b-modal>
				<b-modal centered hide-footer id="viewTitleUpdateModal" title="Enter View Title">
					<ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView" ref="refViewTitleModal"  :namespace="namespace"/>
				</b-modal>

				<b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable" class="modal-edit-social-deliverable" @show="editSocialModalShown" @shown="afterEditSocialModalShown" @hide="editSocialModalHidden" @hidden="removeRoute" no-close-on-backdrop no-close-on-esc>
					<EditSocialModal :allContacts="allContacts" :tabIndex="tabIndex"  ref="refEditSocialModal" @modalDetailUpdated="pushRoute"  :namespace="namespace"/>
				</b-modal>

				<b-modal size="xl" no-close-on-backdrop no-close-on-esc hide-footer id="editOrganicSocialMediaPlanModal"
					title="Edit Organic Social Media Plan" class="modal-edit-deliverable" @hide="editOrganicSocialModalPlanHidden"
					@shown="pushRoute" @hidden="removeRoute">
					<EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndex"
						:namespace="namespace" />
				</b-modal>

				<b-modal id="deleteDeliverableConfirmModal" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable" @cancel="onCancelRemoveDeliverable" ok-title="Yes, Delete">
					<p>Are you sure you want to delete this deliverable?</p>
				</b-modal>

				<b-modal size="lg" hide-footer id="editSocialCampaignModal" title="Edit Social Campaign" class="modal-edit-social-campaign">
					<SocialCampaignDialog ref="refSocialCampaignDialogModal" @socialCampaignClose="createCampaignClose"  :namespace="namespace"/>
				</b-modal>

				<div class="deliverable-header">
					<HeaderIcon
						:totalDeliverableCount="this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0"
						:totalOutletCount="this.outletCount ? this.outletCount : 0"
						:totalDeliverableCountNoMasters="this.deliverableTotalMinusMasters"
						:myWeek="false"
						:isListView="this.isListView"
						 :namespace="namespace"
					/>
				</div>

	    	<SocialTabs/>

				<div class="deliverable-block-wrap">
					<HorizontalMonthPicker :namespace="namespace" :parentDeliverableId="parentDeliverableId"/>
					<div class="deliverable-group-views-wrapper" v-if="false">


			<span class="d-inline-block float-right saved-views-area" :class="[!showUpdateViewText ? 'pt-15' : '', activeView != '-1' ? 'saved-view-active' : '']">


					<div class="text-right" v-show="showUpdateViewText">
						<a href="#" @click="directUpdateView">Click here</a> to save updated view
					</div>
					<div
					class="btn-group float-right add-new__global_search sorting saved-views"
					>
						<button
							class="btn btn-theme ml-2 header-filter-btns dropdown-toggle"
							type="button"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
							@click="updatePerfectScroll"
							v-if="!showCreateNewView"
						>
							<span class="updated-view" v-if="showUpdateViewText"></span>
							<span class="mr-3 view__label truncate-text">{{viewBtnLabel}}</span>
							<i v-if="activeView == '-1'" class="fas fa-fw fa-eye text-primary float-right"></i>
							<i v-else v-b-tooltip.hover="{customClass: 'save__view__tooltip'}" title="Clear View" @click.stop="handleResetFilter()" class="fas fa-fw fa-eye text-primary float-right"></i>
						</button>
						<button
							class="btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view"
							type="button"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
							v-else
						>
							<span class="updated-view" v-if="showUpdateViewText"></span>
							<span class="mr-3 view__label">Views</span>
							<i v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Save View" @click.stop="saveView" class="fas fa-fw fa-eye text-primary float-right"></i>
						</button>
						<div class="dropdown-menu viewmenu-dropdown">
							<div>
								<a
								class="dropdown-item update-view"
								@click="updateView"
								href="#"
								>
									Update View
									<span class="float-right">
										<i class="far fa-edit text-primary"></i>
									</span>
								</a>
								<a
								class="dropdown-item save-view"
								@click="saveView"
								href="#"
								>
									Save View
									<span class="float-right">
										<i class="fas fa-plus-circle text-primary"></i>
									</span>
								</a>
								<perfect-scrollbar class="views__scroll" ref="views__scroll">
									<div>
										<!-- Preset Views (Hardcode) -->
										<a
										class="dropdown-item"
										:class="{active : activeView == userView.id}"
										@click="loadView(userView, index)" :key="'userView'+index+1*Math.random()" v-for="(userView, index) in presetViewsDashboard"
										href="#"
										>
											<div class="preset-icon-wrap">
											</div>
											<span class="save-title">{{ userView.title }}</span>
										</a>

										<!-- User Views -->
										<a
										class="dropdown-item"
										:class="{active : activeView == userView.id}"
										@click="loadView(userView, index)" :key="'userView'+index+1*Math.random()" v-for="(userView, index) in userViewsDeliverable"
										href="#"
										>
											<div class="remove-icon-wrap">
												<span class="remove-icon" @click.stop="removeView(userView.id)">
													<i class="fas fa-trash"></i>
												</span>
											</div>
											<span class="save-title">{{ userView.title }}</span>
										</a>
									</div>
								</perfect-scrollbar>
							</div>
						</div>
					</div>
				</span>
				<!-- Expand / Collapse all button from the header -->
				<span class="d-inline-block float-right pt-15 mr-3 expand-all-area" v-if="false">
					<div
						v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar'"
						class="ml-2 expand-grp cursor-pointer"
						@click="toggleExpandAll(!expandAll)"
						>
						<b-button
							class="header-filter-btns expand-ctrls"
							:class="{'none-active-btn': expandAll}"
							variant="theme"
							v-b-tooltip.hover
							title="Expand"
						>
							<span class="text">Expand All </span>
							<span class="icon"><i class="fas text-primary fa-expand fa-fw"></i></span>
						</b-button>
						<b-button
							class="header-filter-btns expand-ctrls"
							:class="{'none-active-btn': !expandAll}"
							variant="theme"
							v-b-tooltip.hover
							title="Collapse"
						>
							<span class="text">Collapse All</span>
							<span class="icon"><i class="fas text-primary fa-compress fa-fw"></i></span>
						</b-button>
					</div>
				</span>

					<div class="d-inline-block float-right saved-views-area pt-15" v-if="false">
					<div class="text-right">
					<div class="group-by-wrap dropdown">
						<button type="button" class="btn btn-theme header-filter-btns" data-toggle="dropdown">List by <i class="fas text-primary float-right fa-chevron-down fa-fw"></i></button>
						<div class="dropdown-menu">
							<router-link class="dropdown-item" :to="{ name: 'socialMedia', params: { socialGroupBy: 'socialMedia' } }">Dates</router-link>
							<router-link class="dropdown-item" :to="{ name: 'socialMediaGrouped', params: { socialGroupBy: 'socialMediaGrouped' } }">Campaign/Series</router-link>
						</div>
					</div>
					</div>
				</div>

				<div class="d-inline-block float-right saved-views-area pt-15 mr-2" v-if="getSystemSetting('social_media___show_new_campaign_button') || getSystemSetting('social_media___show_new_social_series_button')">
				<div class="new-social-group-container dropdown">
					<button type="button" class="btn btn-theme header-filter-btns" data-toggle="dropdown">New <i class="fas text-primary float-right fa-plus fa-fw"></i></button>
					<div class="dropdown-menu">
						<a class="dropdown-item" href="#" v-if="getSystemSetting('social_media___show_new_campaign_button')" @click="createCampaignClick">Campaign</a>
						<a class="dropdown-item" href="#" v-if="getSystemSetting('social_media___show_new_social_series_button')" @click="createSeriesClick">Series</a>
					</div>
					<!-- <SocialCampaignDialog v-if="isCreateCampaignOpen" @socialCampaignClose="createCampaignClose" :namespace="namespace"/> -->
				</div>
				</div>

					<div class="d-inline-block float-right saved-views-area pt-15 mr-2" v-if="getSystemSetting('social_media___enable_post_import')">
					<div class="text-right">
					<div class="group-by-wrap dropdown">
						<button type="button" class="btn btn-theme header-filter-btns" data-toggle="dropdown">Export/Import<i class="fas text-primary float-right fa-chevron-down fa-fw"></i></button>
						<div class="dropdown-menu">
							<a class="dropdown-item" href="#" @click="exportSocialMediaExcel">Download Excel</a>
							<a class="dropdown-item" href="#" @click="importSocialMediaExcel"  v-if="getSystemSetting('social_media___enable_post_import')">Import Posts</a>
						</div>
					</div>
					</div>
				</div>


			</div><!-- End of views wrapper -->

			<!-- All View -->
			<template v-if="isListAllView">
				<SocialMediaListAll :selectedDeliverable="selectedDeliverable" :listView="true"
					:calendarOnly="false" :hasSocialCampaign="false" :hasSocialSeries="false"
					:socialCampaignId="null" :socialSeriesId="null" :filterQuery="socialMediaFilter" :myWeek="false"
					:expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'
					:parentDeliverableId="null" :namespace="namespace"
					@showEditDeliverableModal="showEditDeliverableModal"
					@deleteSocialMediaDeliverable="deleteDeliverableClick" showNewPostButton="true" :pageCount="pageCount"
					@duplicateDeliverable="duplicateDeliverable"
					 />
			</template>


				<!-- List view -->
				<template v-if="isListView">
					<SocialGroupedByDate :selectedDeliverable="selectedDeliverable" :listView="true" :calendarOnly="false" :hasSocialCampaign="false" :hasSocialSeries="false"  :socialCampaignId="null" :socialSeriesId="null" :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'  @showEditDeliverableModal="showEditDeliverableModal" @deleteSocialMediaDeliverable="deleteSocialMediaDeliverable"  :namespace="namespace"/>
				</template>

				<!-- Grouped view -->
				<template v-if="!isListView && !isListAllView">
					<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="true" :hasSocialCampaign="false" :hasSocialSeries="false"  :socialCampaignId="null" :socialSeriesId="null" :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'  @showEditDeliverableModal="showEditDeliverableModal" @deleteSocialMediaDeliverable="deleteSocialMediaDeliverable"  :namespace="namespace" />

					<!-- campaigns, campaigns with series -->
					<div	
					v-for="(campaign, campaign_idx) in listSocialCampaigns"
							:key="'campaign'+campaign_idx">
								
								<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="false" :hasSocialCampaign="true" :hasSocialSeries="false"  :socialCampaignId="campaign.id" :socialCampaignName="campaign.title" :socialSeriesId="null" :socialSeriesName="null" :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'  @showEditDeliverableModal="showEditDeliverableModal" @deleteSocialMediaDeliverable="deleteSocialMediaDeliverable" :listCount="campaign.list_count" :totalCount="campaign.total_count"  :namespace="namespace"/>

					<div
								v-for="(series, series_idx) in getListSocialSeriesWithSocialCampaign(campaign.id)"
								v-if="series_idx!='totalOutlets'"
								:key="'campaignseries'+series_idx">
									<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="false" :hasSocialCampaign="true" :hasSocialSeries="true" :socialCampaignId="campaign.id"  :socialCampaignName="campaign.title"  :socialSeriesId="series.id" :masterDeliverableId="series.master_deliverable_id" :socialSeriesName="series.title" :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'  @showEditDeliverableModal="showEditDeliverableModal" @deleteSocialMediaDeliverable="deleteSocialMediaDeliverable" :listCount="series.list_count" :totalCount="series.total_count"  :namespace="namespace" />
						</div>
					</div>


					<div
							v-for="(series, series_index) in getListSocialSeriesWithoutSocialCampaign()"
							:key="'seriesAlone-'+series_index">
								<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="false" :hasSocialCampaign="false" :hasSocialSeries="true" :socialCampaignId="null" :socialSeriesId="series.id" :socialSeriesName="series.title" :masterDeliverableId="series.master_deliverable_id" :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'  @showEditDeliverableModal="showEditDeliverableModal" @deleteSocialMediaDeliverable="deleteSocialMediaDeliverable" :listCount="series.list_count" :totalCount="series.total_count"  :namespace="namespace" />
					</div>
				</template>

	      	</div>

	      </div>
      </div>

  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import EditOrganicSocialMediaPlanModal from "../components/deliverables/EditOrganicSocialMediaPlanModal";
import EditSocialModal from "../components/deliverables/EditSocialModal";
import SocialGrouped from "../components/deliverables/SocialGrouped";
import SocialGroupedByDate from "../components/deliverables/SocialGroupedByDate";
import SocialMediaListAll from "../components/deliverables/SocialMediaListAll";
import HeaderControls from "../components/common/HeaderControlsRelatedDeliverablesSocial";
import HorizontalMonthPicker from '../components/common/HorizontalMonthPicker';
import SocialTabs from "../components/common/SocialTabs";
import ViewTitleModal from "../components/common/ViewTitleModal";
import HeaderIcon from '../components/deliverables/HeaderIcon';
import SocialCampaignDialog from "../components/deliverables/SocialCampaignDialog.vue";

export default {
  data() {
		return {
			pageCount:10,
			parentDeliverableId:null,
			namespace:"",
			showRemoveDeliverableId:null,
			filterQuery: {
				query: "",
				filterByDate: false,
				filterByDateCreated: false,
				filterByDateCompleted: false, 
				dateRange: {
					startDate: new Date(),
					endDate: new Date()
				},
				dateCreatedRange: {
					startDate: new Date(),
					endDate: new Date()
				},
				dateCompletedRange: {
					startDate: new Date(),
					endDate: new Date()
				},
				status: [],
				outlet: [],
				deliverableType: [],
				tag: [],
				department: [],
				coordinator: [],
				project: [],
			},
			expandAll: !this.isMobile(),
			activeView: '-1',
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',

			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,

			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,
			isCreateCampaignOpen: false,

			isListView: false,
			isListAllView: true,
			selectedDeliverable: false,
			windowScrollTop: 0,
			tabIndex: 0,
		}
	},
	created() {
		this.fetchSystemSettings();
		this.fetchSocialSeries();
		this.fetchSocialCampaigns();
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchProjects();
		this.fetchViews();
		this.fetchTags();
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchGeoData();
		this.fetchAllCustomFields();
		// this.fetchSocialMediaDeliverablesGrouped();

		this.isListView = false;
		this.isListAllView = true;
	},
computed: {
		...mapState({
	  state (state) {
	    return state[this.namespace]
	  },
	  allContacts (state, getters) {
	    return getters[this.namespace + 'allContacts']
	  },
	  allCustomFields (state, getters) {
	    return getters[this.namespace + 'allCustomFields']
	  },
	  allUsers (state, getters) {
	    return getters['allUsers']
	  },
	  allDeliverablesPaginationData (state, getters) {
	    return getters[this.namespace + 'allDeliverablesPaginationData']
	  },
	  outletCount (state, getters) {
	    return getters[this.namespace + 'outletCount']
	  },
	  getSocialMediaOnlyCalendar (state, getters) {
	    return getters[this.namespace + 'getSocialMediaOnlyCalendar']
	  },
	  getSocialMediaWithSocialCampaign (state, getters) {
	    return getters[this.namespace + 'getSocialMediaWithSocialCampaign']
	  },
	  getListSocialSeriesWithSocialCampaign (state, getters) {
	    return getters[this.namespace + 'getListSocialSeriesWithSocialCampaign']
	  },
	  listSocialCampaigns (state, getters) {
	    return getters[this.namespace + 'listSocialCampaigns']
	  },
	  listSocialSeries (state, getters) {
	    return getters[this.namespace + 'listSocialSeries']
	  },
	  socialCampaigns (state, getters) {
	    return getters[this.namespace + 'socialCampaigns']
	  },
	  socialSeries (state, getters) {
	    return getters[this.namespace + 'socialSeries']
	  },
	  userViews (state, getters) {
	    return getters[this.namespace + 'userViews']
	  },
	  getListSocialSeriesWithoutSocialCampaign (state, getters) {
	    return getters[this.namespace + 'getListSocialSeriesWithoutSocialCampaign']
	  },
	  socialMediaFilter (state, getters) {
	    return getters[this.namespace + 'socialMediaFilter']
	  },
	  deliverableDetail (state, getters) {
	    return getters[this.namespace + 'deliverableDetail']
	  },
	  getSystemSetting (state, getters) {
	    return getters[this.namespace + 'getSystemSetting']
	  },
	  editSocialModal (state, getters) {
	    return getters[this.namespace + 'editSocialModal']
	  },
	  addContactModal (state, getters) {
	    return getters[this.namespace + 'addContactModal']
	  },
	  editContactModal (state, getters) {
	    return getters[this.namespace + 'editContactModal']
	  },
	  editSpokespersonModal (state, getters) {
	    return getters[this.namespace + 'editSpokespersonModal']
	  },
	  editWhoModal (state, getters) {
	    return getters[this.namespace + 'editWhoModal']
	  },
	  	getDeliverableTemplateSlug(state, getters) {
			return getters[this.namespace + "getDeliverableTemplateSlug"];
		},

	}),
  forceUpdateCounter() {
    return this.$store.state.deliverables.forceUpdateCounter
  },
  statuses() {
    let statusField = _.find(this.allCustomFields,
    	{ field_key: "status" });
    if (typeof statusField != "undefined") {
      let valueSet = [],
        data = JSON.parse(statusField.value_set);
      Object.keys(data).forEach(function(item) {
        valueSet.push(data[item]);
      });
      return valueSet;
    }
  },

		// Hardcode
		presetViewsMyWeek() {
			return [
				{
					id: 'p01',
					createdTime: null,
					title: "Default",
					saved_data: `{"query":"","sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"filterByPublishDate":false,"dateRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCreatedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCompletedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"datePublishRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"status":[],"publishStatus":[],"socialNetwork":[],"socialSeries":[],"socialCampaign":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","weekFilterOptions":{"overdue":false,"today":false,"thisWeek":false,"nextWeek":false,"upcoming":false,"noDeadline":false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p1',
					createdTime: null,
					title: "Today",
					saved_data: `{"query":"","sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"filterByPublishDate":true,"dateRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCreatedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCompletedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"datePublishRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"status":[],"publishStatus":[],"socialNetwork":[],"socialSeries":[],"socialCampaign":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","weekFilterOptions":{"overdue":false,"today":false,"thisWeek":false,"nextWeek":false,"upcoming":false,"noDeadline":false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p2',
					createdTime: null,
					title: "This Week",
					saved_data: `{"query": "", "sort": "", "priorityFilter": 0, "outletCompany": [], "filterByDate": false, "filterByDateCreated": false, "filterByDateCompleted": false, "filterByPublishDate": true, "dateRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCreatedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCompletedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "datePublishRange": {"startDate": "${this.$moment().startOf('week').toISOString()}", "endDate": "${this.$moment().endOf('week').toISOString()}"}, "status": [], "publishStatus": [], "socialNetwork": [], "socialSeries": [], "socialCampaign": [], "outlet": [], "deliverableType": [], "tag": [], "department": [], "coordinator": [], "project": [], "noDeparment": "not_accepted", "noOutlet": "not_accepted", "weekFilterOptions": {"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false } }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p3',
					createdTime: null,
					title: "Next Week",
					saved_data: `{"query": "", "sort": "", "priorityFilter": 0, "outletCompany": [], "filterByDate": false, "filterByDateCreated": false, "filterByDateCompleted": false, "filterByPublishDate": true, "dateRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCreatedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCompletedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "datePublishRange": {"startDate": "${this.$moment().add(1, 'week').startOf('week').toISOString()}", "endDate": "${this.$moment().add(1, 'week').endOf('week').toISOString()}"}, "status": [], "publishStatus": [], "socialNetwork": [], "socialSeries": [], "socialCampaign": [], "outlet": [], "deliverableType": [], "tag": [], "department": [], "coordinator": [], "project": [], "noDeparment": "not_accepted", "noOutlet": "not_accepted", "weekFilterOptions": {"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},

				{
					id: 'p5',
					createdTime: null,
					title: "This Month",
					saved_data: `{"query": "", "sort": "", "priorityFilter": 0, "outletCompany": [], "filterByDate": false, "filterByDateCreated": false, "filterByDateCompleted": false, "filterByPublishDate": true, "dateRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCreatedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCompletedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "datePublishRange": {"startDate": "${this.$moment().startOf('month').toISOString()}", "endDate": "${this.$moment().endOf('month').toISOString()}"}, "status": [], "publishStatus": [], "socialNetwork": [], "socialSeries": [], "socialCampaign": [], "outlet": [], "deliverableType": [], "tag": [], "department": [], "coordinator": [], "project": [], "noDeparment": "not_accepted", "noOutlet": "not_accepted", "weekFilterOptions": {"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]
		},
		presetViewsDashboard() {
			const filterForMyWeek = this.presetViewsMyWeek;
			const filterForDashboard =
			[
			]

			return filterForDashboard.concat(filterForMyWeek);
		},
		userViewsDeliverable() {
			return _.filter(this.userViews, {view_type: "socialMedia"});
		},

		deliverableTotalMinusMasters(){
			if(this.allDeliverablesPaginationData.total == undefined){
				return 0;
			}
			let total = this.allDeliverablesPaginationData.total;
			let masters = this.allDeliverablesPaginationData.data.filter(function(deliverable){
				return deliverable.is_master;
			});
			let result = total - masters.length;
			return result;
		}
	},

	components: {
		SocialGrouped,
		SocialGroupedByDate,
		SocialMediaListAll,
		HeaderControls,
		HorizontalMonthPicker,
		EditSocialModal,
		EditOrganicSocialMediaPlanModal,
		HeaderIcon,
		SocialTabs,
		SocialCampaignDialog,
		ViewTitleModal,
	},

	methods: {
		...mapActions({
			fetchSystemSettings (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSystemSettings', payload)
			},
			fetchDeliverables (dispatch, payload) {
				return dispatch(this.namespace + 'fetchDeliverables', payload)
			},
			fetchSocialMediaDeliverablesGrouped (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSocialMediaDeliverablesGrouped', payload)
			},
			createTag (dispatch, payload) {
				return dispatch(this.namespace + 'createTag', payload)
			},
			fetchUsers (dispatch, payload) {
				return dispatch(this.namespace + 'fetchUsers', payload)
			},
			fetchSocialSeries (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSocialSeries', payload)
			},
			fetchSocialCampaigns (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSocialCampaigns', payload)
			},
			fetchActiveUsers (dispatch, payload) {
				return dispatch(this.namespace + 'fetchActiveUsers', payload)
			},
			fetchContacts (dispatch, payload) {
				return dispatch(this.namespace + 'fetchContacts', payload)
			},
			updateFieldValue (dispatch, payload) {
				return dispatch(this.namespace + 'updateFieldValue', payload)
			},
			fetchDepartments (dispatch, payload) {
				return dispatch(this.namespace + 'fetchDepartments', payload)
			},
			fetchActiveDepartments (dispatch, payload) {
				return dispatch(this.namespace + 'fetchActiveDepartments', payload)
			},
			fetchSubjects (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSubjects', payload)
			},
			fetchTags (dispatch, payload) {
				return dispatch(this.namespace + 'fetchTags', payload)
			},
			fetchGeoData (dispatch, payload) {
				return dispatch(this.namespace + 'fetchGeoData', payload)
			},
			fetchAllCustomFields (dispatch, payload) {
				return dispatch(this.namespace + 'fetchAllCustomFields', payload)
			},
			filterDeliverables (dispatch, payload) {
				return dispatch(this.namespace + 'filterDeliverables', payload)
			},
			fetchViews (dispatch, payload) {
				return dispatch(this.namespace + 'fetchViews', payload)
			},
			fetchProjects (dispatch, payload) {
				return dispatch(this.namespace + 'fetchProjects', payload)
			},
			getDeliverableTypes (dispatch, payload) {
				return dispatch(this.namespace + 'getDeliverableTypes', payload)
			},
			fetchUserManageProjects (dispatch, payload) {
				return dispatch(this.namespace + 'fetchUserManageProjects', payload)
			},
			fetchDeliverableCount (dispatch, payload) {
				return dispatch(this.namespace + 'fetchDeliverableCount', payload)
			},
			updateSocialMediaPostUrl (dispatch, payload) {
				return dispatch(this.namespace + 'updateSocialMediaPostUrl', payload)
			},
			createSocialCampaign (dispatch, payload) {
				return dispatch(this.namespace + 'createSocialCampaign', payload)
			},
			createSocialSeries (dispatch, payload) {
				return dispatch(this.namespace + 'createSocialSeries', payload)
			},
		}),
		...mapMutations({
		  setDataLoading (commit, payload) {
		    return commit(this.namespace + 'setDataLoading', payload)
		  },
		}),
		filterUpdate(filterQuery) {
			this.filterQuery = filterQuery
		},
		collapseToggleUpdate(expandAll) {
			this.expandAll = expandAll
		},
  	handleResetFilter() {
			$('.viewmenu-dropdown').removeClass('show');
			this.$root.$emit('resetFilter')
		},
		updatePerfectScroll() {
			let self = this;
			setTimeout(function() {
				if(typeof self.$refs.views__scroll != 'undefined') {
					self.$refs.views__scroll.update();
				}
			}, 1);
		},
		setActiveView() {
			if(localStorage.getItem('socialMediaActiveSave')) {
				this.activeView = localStorage.getItem('socialMediaActiveSave');
				this.viewBtnLabel = localStorage.getItem('socialMediaActiveSaveTitle');
				this.currentViewData = localStorage.getItem('socialMediaActiveSaveData');
				if (!this.activeView.startsWith('p')) this.showUpdateView = true;
			} else {
				this.activeView =  '-1';
				this.viewBtnLabel = 'Views';
				this.showUpdateViewText = false;
			}
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		removeView(viewId) {
			if(viewId == localStorage.getItem('socialMediaActiveSave')) {
				this.resetView();
			}
			this.$store.dispatch(this.namespace + 'removeView', viewId);
		},
		resetView() {
			localStorage.removeItem("socialMediaActiveSave");
			localStorage.removeItem("socialMediaActiveSaveTitle");
			this.setActiveView();
		},
		loadView(viewData) {
			this.currentViewData = JSON.parse(viewData.saved_data);
			let index = viewData.id;
			this.showUpdateView = true;
			this.viewBtnLabel = viewData.title;
			this.activeView = index;
			localStorage.setItem('socialMediaActiveSave', index);
			localStorage.setItem('socialMediaActiveSaveTitle', viewData.title);
			localStorage.setItem('socialMediaActiveSaveData', viewData.saved_data);
			this.$store.commit(this.namespace + "setSocialMediaFilter", this.currentViewData);
			this.$root.$emit('setSaveView', this.$store.getters.socialMediaFilter);
		},
		loadViewFromModal(viewData) {
			this.loadView(viewData);
			this.$bvModal.hide("headerViewSelectModal");
		},
		saveView() {
			this.$bvModal.show("viewTitleModal");
		},
		modalSaveView() {
			this.showNewViewTitleArea = true;
		},
		directUpdateView() {
			this.showUpdateViewText = false;
			let view = "";
			view = this.$store.getters.socialMediaFilter;
			let viewData = {
					title: this.viewBtnLabel,
					filterQuery: view,
					viewId: this.activeView
				};
			let that = this;
			this.$store.dispatch(this.namespace + "saveView", viewData).then(function() {
				localStorage.setItem('socialMediaActiveSaveData', JSON.stringify(view));
				that.setActiveView();
				toast.info('View has been saved.');
			});
		},
		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},
		modalUpdateView() {
			this.showUpdateViewTitleArea = true;
		},
		viewSelectModalHidden() {
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		editSocialModalShown(){
			document.body.classList.add("social-modal-open");
			$("#content").scrollTop(this.windowScrollTop);
		},
		afterEditSocialModalShown() {
			document.body.classList.add("social-modal-shown");
			this.onBVModalDisablePointerEvents();
		},
		editSocialModalHidden() {
			this.windowScrollTop = $("#content").scrollTop();
			document.body.classList.remove("social-modal-open");
			document.body.classList.remove("social-modal-shown");
			$(window).scrollTop(this.windowScrollTop);
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
			this.selectedDeliverable = false;
			this.onBVModalEnablePointerEvents();
		},

		editOrganicSocialModalPlanHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},

		onBVModalEnablePointerEvents() {
			$('#content').removeClass('disable-pointer-events');
		},
		onBVModalDisablePointerEvents() {
			const bodyElement = document.body;
			const modalOpenCount = bodyElement.getAttribute('data-modal-open-count');
			if (modalOpenCount > 0) {
				$('#content').addClass('disable-pointer-events');
				$('#content .deliverable-block-wrap .dtable').addClass('allow-pointer-events');
			}
		},

		showEditDeliverableModal(deliverable, tab) {
			this.windowScrollTop = $(window).scrollTop();
			let deliverableId = null;
			if(typeof deliverable === "object"){
				deliverableId = deliverable.id;
				this.selectedDeliverable = deliverable.id;
				if(deliverable.social_series?.length && !deliverable.manually_updated_at){
					deliverableId = this.getSeriesMasterByDeliverable(deliverable);
				}
			} else {
				deliverableId = deliverable;
				this.selectedDeliverable = deliverableId;
			}
			if(tab === null || tab === undefined){
				tab = 0;
			}
			

			this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
			.then(() => {
				this.pushRoute();
				
				this.$bvModal.show("editSocialModal");
				this.tabIndex = tab;
			});
		},

		pushRoute() {
			if(this.isListView) {
				history.pushState(
					{},
					null,
					'/social-media/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
				)
			} else {
				history.pushState(
					{},
					null,
					'/social-media-grouped/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ?  ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
				)
			}
			let currentTitle = document.title.match(/\(\d+\)\s/g);
			if(!currentTitle) {
				document.title = this.deliverableDetail.title;
			} else {
				document.title = currentTitle[0] + this.deliverableDetail.title;
			}
		},

		removeRoute() {
			history.pushState(
				{},
				null,
				this.$router.currentRoute.matched[0].path
			);
		},

		showDepartment(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		showAltStartEndDate(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug != "media-call";
		},

		// Status toggle from the header
		toggleExpandAll(expandAll) {
			// if(this.isMobile()) {
			// 	if(expandAll) {
			// 		$('.deliverable-status-overview').hide();
			// 		$('.deliverable-dates').css('padding-top', 0);
			// 	} else {
			// 		$('.deliverable-status-overview').show();
			// 		$('.deliverable-dates').css('padding-top', '15px');
			// 	}
			// }
			this.$emit("collapseToggleUpdated", expandAll);
		},

		calculateEndDate(deliverable) {
			let latestDueDate = null;

			if (deliverable.tasks && deliverable.tasks.length > 0) {
				deliverable.tasks.forEach(x => {
					const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
					if (dueDateField && dueDateField.value && (!latestDueDate || latestDueDate < dueDateField.value)) latestDueDate = dueDateField.value;
				});
			}

			return latestDueDate;
		},

		closeVuewSelectModal() {
			this.$bvModal.hide("headerViewSelectModal");
		},

		userCanEditDeliverable() {
			return (this.userAbilities.deleteMediaCall);
		},

		    duplicateDeliverable(deliverable) {
		      let that = this;
		      let slug = "";
		     	slug = this.getDeliverableTemplateSlug(deliverable.deliverable_template_id);

		      if (slug == "social-media") {
			      let that = this;
			      this.$store.dispatch(this.namespace + 'duplicateSocialMedia', {deliverableId:deliverable.id}).then(function() {
			      	// TODO: determine if we need to call fetch social media deliverables grouped.
			        that.$store.dispatch(that.namespace + 'fetchSocialMediaDeliverablesGrouped', {filter:that.socialMediaFilter, page:that.socialMediaFilter.page, pageCount:that.socialMediaFilter.pageCount}).then(function() {
			        	that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function() {
			          	that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable duplicated.');
			          });
			        });
			        that.$bvModal.hide("editSocialModal");
			        // that.$bvModal.show("editSocialModal");
			        that.showEditDeliverableModal(that.deliverableDetail, 0);

			        // TODO: re-open social media modal after duplicating?
			        window.scrollTo(0, 0);
			      });
		      }
		   },

    deleteSocialMediaDeliverable(deliverable) {
    	// deliverable.deleteClicked = true;
    	if (!this.isMobile()) {
    		this.showRemoveDeliverableId = deliverable.id;
    		this.$bvModal.show("deleteDeliverableConfirmModal");
    	} else {
    		if (this.stripRemoveDeliverableId == null) {
    			this.stripRemoveDeliverableId = deliverable.id;
    		} else {
    			this.showRemoveDeliverableId = deliverable.id;
    			this.$bvModal.show("deleteDeliverableConfirmModal");
    		}
    	}
    },
		deleteDeliverableClick(deliverable) {
			// deliverable.deleteClicked = true;
			if (!this.isMobile()) {
				this.showRemoveDeliverableId = deliverable.id;
				this.$bvModal.show("deleteDeliverableConfirmModal");
			} else {
				if (this.stripRemoveDeliverableId == null) {
					this.stripRemoveDeliverableId = deliverable.id;
				} else {
					this.showRemoveDeliverableId = deliverable.id;
					this.$bvModal.show("deleteDeliverableConfirmModal");
				}
			}
		},
		deleteDeliverableClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableId == deliId) {
					that.stripRemoveDeliverableId = null;
				}
			}
		},
		onConfirmRemoveDeliverable() {
			if (this.showRemoveDeliverableId) {
				let that = this;
				this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId:this.showRemoveDeliverableId }).then(function() {
					that.$bvModal.hide("deleteDeliverableConfirmModal");
					that.$bvModal.hide("editSocialModal");
					// TODO: removing a deliverable should only remove it from the list, not replace entire list.
					// that.$store.commit(this.namespace + 'removeMediaCallFromList', deliverableId);
					// that.$store.dispatch(that.namespace + 'countOutlets');
					that.showRemoveDeliverableId = null;
					that.$store.dispatch(that.namespace + 'fetchSocialMediaDeliverablesGrouped').then(function() {
						// toast.hide();
						that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');

						//that.$store.dispatch(that.namespace + 'fetchProjectDeliverable'); // why this?
					});
				});
			}
		},
		onCancelRemoveDeliverable() {
			this.showRemoveDeliverableId = null;
		},

		createCampaignClick() {
			let that = this;

			this.createSocialCampaign({
				title: "Social Campaign"
			}).then(() => {
				this.$nextTick(() => {
					that.$bvModal.show('editSocialCampaignModal');
				});
			});
		},
		calculateCampaignDialogSpace() {
			let target = $(".new-social-group-container");
			const offset = target.offset();
			const dh = $("html").height();
			
			this.$nextTick(() => {
				const dialog = target.find(".social-media-group-popup");
				const dialogHeight = dialog.height();

				if ((offset.top + 100 + dialogHeight) > dh) {
					// Option 1: Calculate the position for the dialog so it doesn't go over the bottom of the page.
					// const dialogTop =  dialogHeight - (dh - offset.top - 100);
					// dialog.css("top", `-${dialogTop}px`);

					// Option 2: Put the dialog on top of the title
					dialog.addClass("is-top");
				}
			});
		},
		createCampaignClose() {
			this.isCreateCampaignOpen = false;
		},
		createSeriesClick() {
			let that = this;

			this.createSocialSeries().then(() => {
				that.$bvModal.show('editSocialModal');
			});
		},
		getSeriesMasterByDeliverable(deliverable){
      let series = deliverable.social_series_deliverables;
      if(series.length){
        let master = series.find(x => x.is_master === 1);
        if(master){
          return master.id;
        }
      }
      return false;
    },

    exportSocialMediaExcel() {
     	this.$root.$emit('exportSocialMediaExcel');
    },

    importSocialMediaExcel() {
     	this.$root.$emit('importSocialMediaExcel');
    }

	},
	beforeUpdate() {
		if(this.activeView != '-1' && ((typeof this.activeView).toLowerCase() == "string" ? !this.activeView.startsWith('p') : true)) {
			$('.views__scroll > div').removeClass('scroll__view__btns');
			$('.update-view').removeClass('d-none');
		} else {
			$('.views__scroll > div').addClass('scroll__view__btns');
			$('.update-view').addClass('d-none');
		}
		if(!$('.deliverable-listing').hasClass('hasFilter')) {
			$('.save-view').addClass('d-none');
			$('.update-view').addClass('d-none');
			this.showUpdateViewText = false;
			$('.views__scroll > div').addClass('scroll__view__btns');
			this.showCreateNewView = false;
		} else {
			$('.save-view').removeClass('d-none');

			if(this.activeView == '-1') {
				this.showCreateNewView = true;
			} else {
				this.showCreateNewView = false;
			}
		}
		if($('.save-view').hasClass('d-none') && $('.update-view').hasClass('d-none')) {
			$('.views__scroll > div').addClass('scroll__view__btns');
		} else {
			$('.views__scroll > div').removeClass('scroll__view__btns');
		}

		this.viewModalShowCreateView = !$('.save-view').hasClass('d-none');
		this.viewModalShowUpdateView = !$('.update-view').hasClass('d-none');
	},
	mounted() {
		document.body.classList.add("social-media");
		if(this.$router.currentRoute.path.indexOf('/social-media/') != -1 || this.$router.currentRoute.path.indexOf('/social-media-grouped/') != -1) {
			let deliverableId = this.$router.currentRoute.path.split('/')[2],
				that = this;
			if (deliverableId) {
				this.$store.dispatch(this.namespace + 'fetchSystemSettings').then(function(){
					that.showEditDeliverableModal(deliverableId);
				});
			}
		}
	},
	watch:{
		$route (to, from){
			// this.isListView = to.name == 'socialMedia';
			this.fetchSocialMediaDeliverablesGrouped();
		}
	}
}
</script>
